/**
 * Converts escaped newline tokens from suggestion-group copy into actual line breaks
 * for insert text areas.
 */
export function toSuggestionInsertText(options: { text: string }): string {
  const { text } = options
  return text.replace(/\r\n/g, "\n").replace(/\\n/g, "\n")
}

/**
 * Converts suggestion text into a single-line chooser label.
 * Escaped or real line breaks are flattened so previews don't render forced new lines.
 */
export function toSuggestionChooserLabel(options: { text: string }): string {
  const { text } = options
  return toSuggestionInsertText({ text }).replace(/\n+/g, " ").replace(/\s{2,}/g, " ").trim()
}
